import React from 'react';

export const RING_RADIUS = 52;
export const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

/**
 * One arc of the score ring, placed by where it starts and how long it is.
 *
 * An SVG circle is drawn as a dashed outline. Setting the dash pattern to
 * "arc length, everything else" leaves exactly one visible dash per lap, and a
 * negative dash offset slides that dash forward to where the arc should begin.
 *
 * Props:
 *   variant (string) - 'correct' or 'incorrect'; picks the colour.
 *   start   (number) - Distance around the circle where the arc begins.
 *   length  (number) - How far around the circle the arc runs.
 */
export const RingArc = ({ variant, start, length }) => (
  <circle
    className={`ringSegment ${variant}`}
    cx="60"
    cy="60"
    r={RING_RADIUS}
    strokeDasharray={`${length} ${RING_CIRCUMFERENCE - length}`}
    strokeDashoffset={-start}
  />
);
